import PropTypes from "prop-types";
import React from "react";

import * as styles from "./styles.module.scss";

const Panel = ({ text }) => <div className={styles.container}>{text}</div>;

Panel.propTypes = {
  text: PropTypes.string.isRequired,
};

export default Panel;
